import { Apartment } from "./types";

export const apartmentResponse: Apartment[] = [
  {
    id: 1,
    apartmenttypeit: "Monolocale",
    apartmenttypeen: "One-Room Apartment",
    descriptionit:
      "Il monolocale, con i suoi caratteristici arredi dalle tinte chiare, in tipico stile sardo, è composta da zona giorno con angolo cottura e zona notte con letto Queen size e bagno con doccia. All'esterno la casa ha una zona esclusivo con vista mare e antistante prato comune.Tutte le case condividono servizi comuni quali parcheggio esterno esclusivo, docce esterne, barbecue, lavatrice grande prato.",
    descriptionen:
      "The studio apartment, with its characteristic light-colored furnishings in typical Sardinian style, consists of a living area with a kitchenette and a sleeping area with a Queen size bed and a bathroom with a shower. Outside, the house has an exclusive area with sea view and a common lawn in front. All the houses share common services such as exclusive outdoor parking, outdoor showers, barbecue, washing machine, and a large lawn.",
    doublebed: 1,
    singlebed: 0,
    sofabed: 0,
    bathnumber: 1,
    haswifi: true,
    hasairconditioning: true,
    photos: [
      {
        id: "93ac62ed-10eb-4d7a-93d0-c036f059a2b4",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/bxacrkg0bfu2xpddxjsa.webp",
        isMain: false,
        publicId: "Monolocali/bxacrkg0bfu2xpddxjsa",
        appartmentId: 1,
      },
      {
        id: "16464be6-892f-46d2-8574-d7549dd2040e",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/ezbawlgqcqnfguyrszw2.webp",
        isMain: false,
        publicId: "Monolocali/ezbawlgqcqnfguyrszw2",
        appartmentId: 1,
      },
      {
        id: "6a3dddd1-0080-440b-b179-27b77904b1e4",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/niey5la7l1kaqgl4kl5f.webp",
        isMain: false,
        publicId: "Monolocali/niey5la7l1kaqgl4kl5f",
        appartmentId: 1,
      },
      {
        id: "64a22608-9178-4478-a5c7-bb27f223555a",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/ojsiibfnsj5wevfiivwl.webp",
        isMain: false,
        publicId: "Monolocali/ojsiibfnsj5wevfiivwl",
        appartmentId: 1,
      },
      {
        id: "5c7b62fd-5835-4243-af54-7c446db681df",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/pu20cuypqkczhh4d4t7y.webp",
        isMain: false,
        publicId: "Monolocali/pu20cuypqkczhh4d4t7y",
        appartmentId: 1,
      },
      {
        id: "2ed3b530-43c7-4b2d-a192-2a3aef4edf83",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/smpzgfvewuakitn90ukd.webp",
        isMain: false,
        publicId: "Monolocali/smpzgfvewuakitn90ukd",
        appartmentId: 1,
      },
      {
        id: "dbbccb66-4d19-401f-9a5e-be2fff5604c4",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/t3xpatiwvcrju06z96sg.webp",
        isMain: false,
        publicId: "Monolocali/t3xpatiwvcrju06z96sg",
        appartmentId: 1,
      },
      {
        id: "e1354dc7-bb2e-4930-9ada-19fa0bbf11c0",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/t7lkfsl967zixu5xylw1.webp",
        isMain: false,
        publicId: "Monolocali/t7lkfsl967zixu5xylw1",
        appartmentId: 1,
      },
      {
        id: "e4b5ac54-7160-459e-aaba-565857522742",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/uozjvcyms0hvnpshyesw.webp",
        isMain: false,
        publicId: "Monolocali/uozjvcyms0hvnpshyesw",
        appartmentId: 1,
      },
      {
        id: "e6f983a3-f78c-40a2-8ca2-2ccbf4547c3a",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724172093/Monolocali/y6mlwuyvgpadnzz6oshg.webp",
        isMain: false,
        publicId: "Monolocali/y6mlwuyvgpadnzz6oshg",
        appartmentId: 1,
      },
    ],
  },
  {
    id: 2,
    apartmenttypeit: "Bilocale",
    apartmenttypeen: "Two-Rooms Apartment",
    descriptionit:
      "Il bilocale con i suoi caratteristici arredi dalle tinte chiare, in tipico stile sardo, è costituito da soggiorno con angolo cottura, disimpegno con armadio a muro, camera con letto Queen size vista mare, bagno con doccia. All'esterno la casa ha un patio coperto esclusivo con vista mare e antistante prato comune. Tutte le case condividono servizi comuni quali parcheggio esterno esclusivo, docce esterne, barbecue, lavatrice e grande prato.",
    descriptionen:
      "The one-bedroom apartment, with its characteristic light-colored furnishings in typical Sardinian style, consists of a living room with a kitchenette, a hallway with a built-in wardrobe, a bedroom with a Queen size bed and sea view, and a bathroom with a shower. Outside, the house has an exclusive covered patio with sea view and a common lawn in front. All the houses share common services such as exclusive outdoor parking, outdoor showers, barbecue, washing machine, and a large lawn.",
    doublebed: 1,
    singlebed: 0,
    sofabed: 0,
    bathnumber: 1,
    haswifi: true,
    hasairconditioning: true,
    photos: [
      {
        id: "44789ed6-3df2-4e0b-99d9-000c93ae3e75",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/cavpf6xxsrqu2h9wg3pf.webp",
        isMain: false,
        publicId: "Bilocali/cavpf6xxsrqu2h9wg3pf",
        appartmentId: 2,
      },
      {
        id: "d5ce92f4-deb7-4750-84ca-249f25016c24",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/czv9bf48oyzrrpzk2r58.webp",
        isMain: false,
        publicId: "Bilocali/czv9bf48oyzrrpzk2r58",
        appartmentId: 2,
      },
      {
        id: "b92a70d0-127b-4c8b-b379-503c045b14b6",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/ebnswowmqatgydkeyyks.webp",
        isMain: false,
        publicId: "Bilocali/ebnswowmqatgydkeyyks",
        appartmentId: 2,
      },
      {
        id: "dae4298a-83ef-400f-8896-e734a05100c8",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/jfgysa2aowqatr4xkdsb.webp",
        isMain: false,
        publicId: "Bilocali/jfgysa2aowqatr4xkdsb",
        appartmentId: 2,
      },
      {
        id: "ddc37bce-ae5d-4e8a-acd3-ae847d303a98",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/jzhjqbezwucyfzmxr22w.webp",
        isMain: false,
        publicId: "Bilocali/jzhjqbezwucyfzmxr22w",
        appartmentId: 2,
      },
      {
        id: "5fea1ca7-827e-4944-bb4f-808cdab82b04",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113266/Bilocali/ktvornch6tac9jvaftc6.webp",
        isMain: false,
        publicId: "Bilocali/ktvornch6tac9jvaftc6",
        appartmentId: 2,
      },
      {
        id: "ef6564fe-0b65-40e1-b807-471819ce7e79",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/svr3uoc9hhiz1mddqwt8.webp",
        isMain: false,
        publicId: "Bilocali/svr3uoc9hhiz1mddqwt8",
        appartmentId: 2,
      },
      {
        id: "04bb8098-2f6e-43e1-afe1-db0d8ff6e371",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113268/Bilocali/ug1ffw7reyahox9tfajf.webp",
        isMain: false,
        publicId: "Bilocali/ug1ffw7reyahox9tfajf",
        appartmentId: 2,
      },
      {
        id: "c69e811e-842c-477b-827f-ab47970965ed",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/vdcod3opeqeak2vkewwl.webp",
        isMain: false,
        publicId: "Bilocali/vdcod3opeqeak2vkewwl",
        appartmentId: 2,
      },
      {
        id: "c732a927-10d6-4c66-82cf-78caef350093",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723113267/Bilocali/ym79thsrat4gyi57bvig.webp",
        isMain: false,
        publicId: "Bilocali/ym79thsrat4gyi57bvig",
        appartmentId: 2,
      },
    ],
  },
  {
    id: 3,
    apartmenttypeit: "Trilocale",
    apartmenttypeen: "Three-Rooms Apartment",
    descriptionit:
      "Il trilocale con i suoi caratteristici arredi dalle tinte chiare, in tipico stile sardo, è costituito da soggiorno con angolo cottura, camera con letto Queen size, camera con due letti singoli affiancabili, piccolo ripostiglio, bagno con doccia.All'esterno la casa ha un patio coperto esclusivo con vista mare e antistante prato comune.Tutte le case condividono servizi comuni quali parcheggio esterno esclusivo, docce esterne, barbecue, lavatrice e grande prato.",
    descriptionen:
      "The three-room apartment, with its characteristic light-colored furnishings in typical Sardinian style, consists of a living room with a kitchenette, a bedroom with a Queen size bed, a bedroom with two single beds that can be joined, a small storage room, and a bathroom with a shower. Outside, the house has an exclusive covered patio with sea view and a common lawn in front. All the houses share common services such as exclusive outdoor parking, outdoor showers, barbecue, washing machine, and a large lawn.",
    doublebed: 1,
    singlebed: 2,
    sofabed: 1,
    bathnumber: 1,
    haswifi: true,
    hasairconditioning: true,
    photos: [
      {
        id: "4d5a10a0-eda1-487b-829a-c641ce73efce",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173654/Trilocali/er2gu62sacpt5zgwe90q.jpg",
        isMain: false,
        publicId: "Trilocali/er2gu62sacpt5zgwe90q",
        appartmentId: 3,
      },
      {
        id: "53e9575c-e7ac-4f5d-abf8-b86d32ed7bb8",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173655/Trilocali/fagviaaapymvcjjzaxb0.jpg",
        isMain: false,
        publicId: "Trilocali/fagviaaapymvcjjzaxb0",
        appartmentId: 3,
      },
      {
        id: "8bfc9b5f-0c45-4de3-a06d-a720a50e81f2",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173653/Trilocali/nuljsntsvimvaayk0zry.jpg",
        isMain: false,
        publicId: "Trilocali/nuljsntsvimvaayk0zry",
        appartmentId: 3,
      },
      {
        id: "51592fbf-39ab-405c-93de-2b7d17d6bfd7",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173653/Trilocali/quuoxt16wzrahdhknx64.jpg",
        isMain: false,
        publicId: "Trilocali/quuoxt16wzrahdhknx64",
        appartmentId: 3,
      },
      {
        id: "53f13dde-1da2-473c-a19c-02a4b0eabcf0",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173654/Trilocali/ty9bzsmaztaimmtcwbrh.jpg",
        isMain: false,
        publicId: "Trilocali/ty9bzsmaztaimmtcwbrh",
        appartmentId: 3,
      },
      {
        id: "4697f29c-4829-4e50-bd3b-62d5be729f6e",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173654/Trilocali/vjar3xccirsfgnti1gz3.jpg",
        isMain: false,
        publicId: "Trilocali/vjar3xccirsfgnti1gz3",
        appartmentId: 3,
      },
      {
        id: "b95b9f73-a5ed-485a-a09a-d1b1fe604e75",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173654/Trilocali/y0pmrrkpuj6o96erhegf.jpg",
        isMain: false,
        publicId: "Trilocali/y0pmrrkpuj6o96erhegf",
        appartmentId: 3,
      },
      {
        id: "6581eab9-74f6-4101-8c29-df9222ce6569",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173654/Trilocali/yaqvppam6t1qecownhtr.jpg",
        isMain: false,
        publicId: "Trilocali/yaqvppam6t1qecownhtr",
        appartmentId: 3,
      },
      {
        id: "76ba29e7-360f-4686-9a08-02ac0ed6b719",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173654/Trilocali/z29nyg8vozlxhwpxdghq.jpg",
        isMain: false,
        publicId: "Trilocali/z29nyg8vozlxhwpxdghq",
        appartmentId: 3,
      },
      {
        id: "9fb75cf8-d72b-4337-95ca-edbd5a558a92",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724173653/Trilocali/zm78kmzr30n6u5qdtaet.jpg",
        isMain: false,
        publicId: "Trilocali/zm78kmzr30n6u5qdtaet",
        appartmentId: 3,
      },
    ],
  },
  {
    id: 4,
    apartmenttypeit: "Trilocale Premium",
    apartmenttypeen: "Premium Three-Rooms Apartment",
    descriptionit:
      "L'appartamento standard è un trilocale, con i suoi caratteristici arredi dalle tinte chiare, in tipico stile sardo, è costituito da soggiorno con angolo cottura, due camere matrimoniali con letto Queen size, bagno con doccia.All'esterno la casa ha una zona esclusiva all’ombra di un grande ulivo, immersa nella flora mediterranea.Tutte le case condividono servizi comuni quali parcheggio esterno esclusivo, docce esterne, barbecue, lavatrice e grande prato.",
    descriptionen:
      "The standard apartment is a three-room unit, with its characteristic light-colored furnishings in typical Sardinian style, consists of a living room with a kitchenette, two double bedrooms with Queen size beds, and a bathroom with a shower. Outside, the house has an exclusive area in the shade of a large olive tree, surrounded by Mediterranean flora. All the houses share common services such as exclusive outdoor parking, outdoor showers, barbecue, washing machine, and a large lawn.",
    doublebed: 2,
    singlebed: 0,
    sofabed: 0,
    bathnumber: 1,
    haswifi: true,
    hasairconditioning: true,
    photos: [
      {
        id: "06f332b6-69c8-45ff-9757-fb69957f98f7",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114814/Appartment/cqybiegctqkjjhma7wz8.webp",
        isMain: false,
        publicId: "Appartment/cqybiegctqkjjhma7wz8",
        appartmentId: 4,
      },
      {
        id: "248323fb-8a7a-4bfe-9cb5-1b5f99c47d9c",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114424/Appartment/cus5wfytrgkipjgeib18.webp",
        isMain: false,
        publicId: "Appartment/cus5wfytrgkipjgeib18",
        appartmentId: 4,
      },
      {
        id: "48167b87-8f97-4e6d-ba94-ae3515e31d04",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114423/Appartment/f0jrpos2pwyawiiyevs4.webp",
        isMain: false,
        publicId: "Appartment/f0jrpos2pwyawiiyevs4",
        appartmentId: 4,
      },
      {
        id: "5532df4f-c26b-44c1-96ad-495c3f76ca26",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114424/Appartment/jtpnwdewi8qo8lxkdbll.webp",
        isMain: false,
        publicId: "Appartment/jtpnwdewi8qo8lxkdbll",
        appartmentId: 4,
      },
      {
        id: "e4856f9d-f97c-4d45-8bcd-e64d6e00c49d",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114423/Appartment/kkbpzpps7a5gkfang7am.webp",
        isMain: false,
        publicId: "Appartment/kkbpzpps7a5gkfang7am",
        appartmentId: 4,
      },
      {
        id: "33e83431-92dc-4445-89bb-d2b864187158",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114424/Appartment/rp32qqmtomhocjkrjojs.webp",
        isMain: false,
        publicId: "Appartment/rp32qqmtomhocjkrjojs",
        appartmentId: 4,
      },
      {
        id: "4eb0c6a7-77b1-4723-bd58-d033a901b9b2",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114423/Appartment/uaguckixyzbqwkijbodg.webp",
        isMain: false,
        publicId: "Appartment/uaguckixyzbqwkijbodg",
        appartmentId: 4,
      },
      {
        id: "065f233d-07a4-40e8-abac-b1816be3944b",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114423/Appartment/v7wxp1yotgnwwcgactpb.webp",
        isMain: false,
        publicId: "Appartment/v7wxp1yotgnwwcgactpb",
        appartmentId: 4,
      },
      {
        id: "a4f38e54-dbf1-4397-89fb-f1611bc9f0ce",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114423/Appartment/vfv6pw0wcwamc4qrhkrm.webp",
        isMain: false,
        publicId: "Appartment/vfv6pw0wcwamc4qrhkrm",
        appartmentId: 4,
      },
      {
        id: "cd8bb59d-e200-46ee-afaa-8b0120e0d6ec",
        url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1723114423/Appartment/yh3oacdya5yrkvbql2dj.webp",
        isMain: false,
        publicId: "Appartment/yh3oacdya5yrkvbql2dj",
        appartmentId: 4,
      },
    ],
  },
];

export const imagesResponse = [
  {
    id: "f67dd078-dfa6-4ad0-81b4-d5167567a174",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/fgpqvxe21f3qqeq1r4y9.webp",
    isMain: false,
    publicId: "Esterni/fgpqvxe21f3qqeq1r4y9",
    appartmentId: 0,
  },
  {
    id: "952b0ce2-172f-4a0d-b1a6-e7ac2848ab3e",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/fjnoaatnix6qkdmv0mkk.webp",
    isMain: false,
    publicId: "Esterni/fjnoaatnix6qkdmv0mkk",
    appartmentId: 0,
  },
  {
    id: "049ffb91-d333-4732-9899-b9e81f7fc8a9",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059895/Esterni/othhbkri6xeqnlfqphon.webp",
    isMain: false,
    publicId: "Esterni/othhbkri6xeqnlfqphon",
    appartmentId: 0,
  },
  {
    id: "a78d7d09-e5e0-44bf-bee9-670d04532884",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/oubgesn7yonl51wmdnfl.webp",
    isMain: false,
    publicId: "Esterni/oubgesn7yonl51wmdnfl",
    appartmentId: 0,
  },
  {
    id: "8a2c265b-1163-4973-a540-2c0d19478492",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059895/Esterni/pvpjdirzxmvnr0mjawpt.webp",
    isMain: false,
    publicId: "Esterni/pvpjdirzxmvnr0mjawpt",
    appartmentId: 0,
  },
  {
    id: "0c71a18f-152c-4247-b274-e790cbd7eff6",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/rq5qcmyf7wjkd8jilmal.webp",
    isMain: false,
    publicId: "Esterni/rq5qcmyf7wjkd8jilmal",
    appartmentId: 0,
  },
  {
    id: "82e0e7fb-2b08-417a-8c6a-61e29d03a9ad",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/rr6zkvnriutvdygagynw.webp",
    isMain: false,
    publicId: "Esterni/rr6zkvnriutvdygagynw",
    appartmentId: 0,
  },
  {
    id: "66b68b1e-0f5a-4a00-a707-506504aee0cb",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/tls98vqctvj3ssuvbxz9.webp",
    isMain: false,
    publicId: "Esterni/tls98vqctvj3ssuvbxz9",
    appartmentId: 0,
  },
  {
    id: "138db907-ef6b-4089-b647-dc64ebb57adb",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/ubcdw4jzrxbibvnnbgyx.webp",
    isMain: false,
    publicId: "Esterni/ubcdw4jzrxbibvnnbgyx",
    appartmentId: 0,
  },
  {
    id: "0940f937-f60c-4881-880b-d43432893165",
    url: "https://res.cloudinary.com/dcer0ek6h/image/upload/v1724059896/Esterni/uzllsf86akwqerfffgh0.webp",
    isMain: false,
    publicId: "Esterni/uzllsf86akwqerfffgh0",
    appartmentId: 0,
  },
];

export const videoLink =
  "https://res.cloudinary.com/dcer0ek6h/video/upload/v1724061761/Esterni/jhn7jxdha4mbczsueqvc.mp4";
